export default (context, payload) => {
    const moduleId = context.getters.moduleId;
    const apiData = context.rootState.appState.data;
    const setAttribute = payload.oneLni.storeUtils.setAttribute;

    // Set labels manually
    setAttribute(context, `${moduleId}_first-name`, 'labelText', apiData.firstName);
    setAttribute(context, `${moduleId}_last-name`, 'labelText', apiData.lastName);
    setAttribute(context, `${moduleId}_phone-number_phone`, 'labelText', apiData.phone);
    setAttribute(context, `${moduleId}_email-address_input-text`, 'labelText', apiData.email);

    setAttribute(context, `${moduleId}_address`, 'labelText', apiData.address);
    setAttribute(context, `${moduleId}_address`, 'countyOptions', apiData.counties);

    setAttribute(context, `${moduleId}_preferred-language`, 'labelText', apiData['contact.preferredLanguage.label']);
    setAttribute(context, `${moduleId}_preferred-language`, 'options', apiData['contact.preferredLanguage.options']);

    setAttribute(context, `${moduleId}_position-title`, 'labelText', apiData['contact.positionTitle.label']);

    context.commit(`${payload.sourceId}/ADD_TRACKED_ERRORS`, [
        `${moduleId}_first-name`,
        `${moduleId}_last-name`,
        `${moduleId}_phone-number`,
        `${moduleId}_preferred-language`,
        `${moduleId}_email-address`,
    ], {
        root: true,
    });
};